import PropTypes from 'prop-types'
import { createContext, memo, useContext } from 'react'
import useUser from './hooks/useUser'

// The context
export const UserContext = createContext({})

// Use user context utility
export const useUserContext = () => {
  const context = useContext(UserContext)

  return context
}

/**
 * The `UserProvider`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the react element
 */
function UserProvider (props) {
  const { children } = props
  const ctx = useUser()

  return <UserContext.Provider value={ctx}>{children}</UserContext.Provider>
}

/** @type {object} */
UserProvider.propTypes = {
  children: PropTypes.node
}

/** @type {object} */
UserProvider.defaultProps = {
  children: []
}

export default memo(UserProvider)
